export const kPluginAttributeDragId = "plugin-attribute-drag"
